import { createComponent } from "../../../../helpers/React";
import styles from "./TableWrapper.scss";

export const TableWrapper = createComponent({
  tag: "div",
  className: styles.tableWrapper,
});
